import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { styled } from 'styled-components';
import { useIsMobileDevice } from '@hivebrite/react-hooks';
import { Box } from '@design-system/box';
import { Button } from '@design-system/button';
import { __ } from '@design-system/i18n';
import { useBreakpoint } from '@design-system/theme';
import { COL_WIDTH_DEFAULT, ITEMS_PER_PAGE_DEFAULT } from '../../constants';
import { Col } from '../Col';
import { Row } from '../Row';
export const WrappingRow = ({ ItemComponent, LoadingItemComponent, colWidthBreakpoints = COL_WIDTH_DEFAULT, items = [], loading, onLoadMore, perPageBreakpoints = ITEMS_PER_PAGE_DEFAULT, total, }) => {
    const breakpoint = useBreakpoint();
    const isMobileDevice = useIsMobileDevice();
    const perPage = perPageBreakpoints[breakpoint];
    const colWidth = colWidthBreakpoints[breakpoint];
    const [page, setPage] = useState(1);
    const [scrollIfNeeded, setScrollIfNeeded] = useState(false);
    const targetFirstItemIndex = useRef((page - 1) * perPage);
    const handleLoadNextPage = useCallback(() => {
        setPage((prev) => prev + 1);
        setScrollIfNeeded(true);
    }, []);
    useEffect(() => {
        const newPage = Math.floor(targetFirstItemIndex.current / perPage) + 1;
        if (newPage !== page) {
            setPage(newPage);
            targetFirstItemIndex.current = (newPage - 1) * perPage;
        }
    }, [page, perPage]);
    useEffect(() => {
        targetFirstItemIndex.current = (page - 1) * perPage;
    }, [page, perPage]);
    useEffect(() => {
        if (onLoadMore && !loading) {
            const requiredItems = page * perPage;
            const currentTotal = items.length;
            if (currentTotal < total && requiredItems > currentTotal) {
                onLoadMore(requiredItems);
            }
        }
    }, [items, loading, onLoadMore, page, perPage, total]);
    const setLastRef = (element) => {
        if (element && scrollIfNeeded && !loading && page > 1 && !isMobileDevice) {
            setScrollIfNeeded(false);
            const firstLoadedItemIdx = (page - 1) * perPage;
            const firstItemOfPage = element.parentElement.children[firstLoadedItemIdx];
            const focusableElement = firstItemOfPage.querySelector('[tabindex="0"]');
            focusableElement.focus();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(StyledRow, { children: [items.slice(0, page * perPage).map((item, index) => (_jsx(StyledCol, { ref: index === page * perPage - 1 || index === total - 1
                            ? setLastRef
                            : null, width: colWidth, children: _jsx(ItemComponent, Object.assign({}, item, { index: index })) }, index))), loading &&
                        Array.from({ length: perPage - (items.length % perPage) })
                            .fill(null)
                            .map((_, index) => (_jsx(StyledCol, { width: colWidth, children: _jsx(LoadingItemComponent, { index: items.length + index }) }, items.length + index)))] }), perPage * page < total && (_jsx(Row, { children: _jsx(Col, { pt: 2, width: 12 / 12, children: _jsx(Box, { flex: 1, justifyContent: "center", children: _jsx(Button, { isLoading: loading, onClick: handleLoadNextPage, children: __('Load More') }) }) }) }))] }));
};
const StyledRow = styled(Row) `
  flex-wrap: 'wrap';
`;
const StyledCol = styled(Col).attrs(() => ({
    pr: { _: 3, m: 0 },
})) ``;
//# sourceMappingURL=index.js.map